import React from "react";
import moment from "moment";
import logo from "../../../assets/images/asset-planet-background.png";

export const AssetsPDFReport = ({
  assetsList,
  inventoryList,
  collectiblesList,
  totalAssets,
  clientName,
  chartImage,
}) => {
  return (
    <div
      id="assets-report-pdf"
      style={{
        padding: "60px 30px",
        backgroundColor: "#fff",
        width: "900px",
        margin: "0 auto",
        fontFamily: "'Inter', sans-serif",
        color: "#000",
        boxSizing: "border-box",
      }}
    >
      {/* Logo and Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "50px",
          borderBottom: "1px solid #eee",
          paddingBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            alt="Logo"
            style={{
              height: "50px",
              marginRight: "20px",
              objectFit: "contain",
            }}
          />
        </div>
      </div>

      <h1
        style={{
          fontSize: "40px",
          fontWeight: "800",
          marginBottom: "40px",
          color: "#1c1c1c",
          letterSpacing: "-1px",
        }}
      >
        Assets
      </h1>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "40px",
          backgroundColor: "#f9f9f9",
          padding: "20px",
          borderRadius: "12px",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
              textTransform: "uppercase",
              marginBottom: "6px",
            }}
          >
            Client Name
          </div>
          <div
            style={{ fontSize: "18px", fontWeight: "bold", color: "#1F3C88" }}
          >
            {clientName || "Roger Thames"}
          </div>
        </div>
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
              textTransform: "uppercase",
              marginBottom: "6px",
            }}
          >
            Total Assets
          </div>
          <div
            style={{ fontSize: "18px", fontWeight: "bold", color: "#1F3C88" }}
          >
            ${totalAssets || "0.00"}
          </div>
        </div>
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
              textTransform: "uppercase",
              marginBottom: "6px",
            }}
          >
            Report Generated
          </div>
          <div
            style={{ fontSize: "18px", fontWeight: "bold", color: "#1F3C88" }}
          >
            {moment().format("MMMM D, YYYY")}
          </div>
        </div>
      </div>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Asset by Account Type
      </h2>

      <div
        style={{
          marginBottom: "60px",
          textAlign: "center",
          minHeight: "350px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #f0f0f0",
        }}
      >
        {chartImage ? (
          <img
            src={chartImage}
            alt="Asset Chart"
            style={{
              maxWidth: "100%",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        ) : (
          <div style={{ color: "#ccc", fontSize: "18px", fontStyle: "italic" }}>
            Chart data is being processed...
          </div>
        )}
      </div>
      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Assets
      </h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0",
          marginBottom: "60px",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#1F3C88", color: "#fff" }}>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Name of Asset
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Monetary Value
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Account Type
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Held Where
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Value as of Date
            </th>
          </tr>
        </thead>
        <tbody>
          {assetsList && assetsList.length > 0 ? (
            assetsList.map((asset, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                }}
              >
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {asset["Name of Asset"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#1F3C88",
                  }}
                >
                  $
                  {asset["Monetary Value"]
                    ? asset["Monetary Value"].toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {asset["Account Type/Titled"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {asset["Held Where"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {asset["Value as of Date"]
                    ? moment(asset["Value as of Date"]).format("MMM, YYYY")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "16px",
                }}
              >
                No assets found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Inventory
      </h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0",
          marginBottom: "60px",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#1F3C88", color: "#fff" }}>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Property Name
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Monetary Value
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Account Type
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Held Where
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Value as of Date
            </th>
          </tr>
        </thead>
        <tbody>
          {inventoryList && inventoryList.length > 0 ? (
            inventoryList.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                }}
              >
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {item["Name of Asset"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#1F3C88",
                  }}
                >
                  $
                  {item["Monetary Value"]
                    ? item["Monetary Value"].toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Account Type/Titled"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Held Where"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Value as of Date"]
                    ? moment(item["Value as of Date"]).format("MMM, YYYY")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "16px",
                }}
              >
                No inventory items found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Collectibles
      </h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0",
          marginBottom: "60px",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#1F3C88", color: "#fff" }}>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Description
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Monetary Value
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Account Type
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Held Where
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Value as of Date
            </th>
          </tr>
        </thead>
        <tbody>
          {collectiblesList && collectiblesList.length > 0 ? (
            collectiblesList.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                }}
              >
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {item["Name of Asset"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#1F3C88",
                  }}
                >
                  $
                  {item["Monetary Value"]
                    ? item["Monetary Value"].toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Account Type/Titled"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Held Where"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Value as of Date"]
                    ? moment(item["Value as of Date"]).format("MMM, YYYY")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "16px",
                }}
              >
                No collectibles found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div
        style={{
          fontSize: "13px",
          lineHeight: "1.6",
          color: "#000000",
          marginTop: "60px",
          textAlign: "center",
          padding: "20px 60px",
          borderTop: "1px solid #eee",
        }}
      >
        <strong>Confidential & Unaudited:</strong> This report is intended solely for the named recipient and is for informational purposes only. The data reflects information provided by the user and has not been audited by <strong>Asset Planet.</strong> <strong>Asset Planet</strong> makes no warranty regarding the data's accuracy or completeness and does not provide financial, legal, or tax advice through this report. Users are encouraged to consult with a qualified professional for their specific circumstances.
      </div>
    </div>
  );
};
